import io from 'socket.io-client';

export function getCognitoTokensFromLocalStorage() {
  let idToken = null;
  let accessToken = null;
  Object.keys(localStorage).forEach((key: string) => {
    if (key.endsWith('idToken') && key.startsWith('CognitoIdentityServiceProvider')) {
      idToken = localStorage.getItem(key);
    }
    if (key.endsWith('accessToken') && key.startsWith('CognitoIdentityServiceProvider')) {
      accessToken = localStorage.getItem(key);
    }
  });

  if (idToken && accessToken) {
    return {
      idToken,
      accessToken,
    };
  } else {
    console.error('could not find cognito id token in local storage');
    return null;
  }
}

/**
 * Creates instance of socket io client
 * @param {string} url
 * @param {string} sessionId
 * @param {boolean} disableSpeak
 * @return {any}
 */
export function createSocket(url: string, sessionId: string, disableSpeak: boolean = false) {
  console.log('083023 createSocket', url, sessionId);
  if (!url) {
    throw new Error('CHATBOT_URL environment variable not defined');
  }
  const socket = io(url);

  socket.on('error', function(err: any) {
    console.error('socket.io error', err);
  });

  socket.on('connect_error', function(err: any) {
    console.error('socket.io connection error', err);
  });

  socket.on('connect_failed', function(err: any) {
    console.error('socket.io connection failed error', err);
  });

  socket.on('connect', function() {
    socket.emit('session', { sessionId, disableSpeak });
  });
  return socket;
}

/**
 * Add a user to the specified org 
 * @param {string} emailToAdd
 * @param {string} orgId
 * @param {string} serverUrl
 */
/*export async function addUser(emailToAdd: string, orgId: string, serverUrl:string) {
    var url = `${serverUrl}/api/inviteuser`;
    console.log("021822 url", url);
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    //headers.append("Content-Type", "text/plain");

    const token = localStorage.getItem('syncarto_jwt');
    headers.append("Authorization", token ? `Bearer ${token}` : "");
    let query = {
      "orgId":orgId,
      "email":emailToAdd
    }
    var raw = JSON.stringify(query);
    
    const response = await fetch(url, {
        method: 'POST',
        headers: headers,
        //mode: 'no-cors',
        body: raw 
    });
    
    const text = await response.text();
    const data = text ? JSON.parse(text) : [];

    return data;
}
*/

/**
 * Fetch the jwtToken used to authenticate graphql and tileserver requests.
 * @param {string} serverUrl
 */
export async function fetchJwtToken(serverUrl: string) {
  if (localStorage.getItem('syncarto_jwt')) {
    return new Promise((resolve) => {
      resolve(localStorage.getItem('syncarto_jwt'));
    });
  }

  return fetch(serverUrl + '/jwtToken', {
    method: 'POST',
    // token should get sent in cookie
    credentials: 'include',
    mode: 'cors',
  })
    .then(function(response) {
      if (response.ok) {
        return response.text();
      }
      throw new Error(''+response.status);
    })
    .then(function(data) {
      const token = data;
      localStorage.setItem('syncarto_jwt', token);
      console.log('got jwt token: ', token);
      return token;
    });
}

/**
 * Removes one or more trailing slashes from URL
 * @param {string} url
 */
export function removeTrailingSlashes(url: string) {
  return url.replace(/\/+$/, ''); 
}

export function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function isInt(n: number) {
  return n % 1 === 0;
}

export async function serverReqesut(url: string, method: string, body: any) {
  var headers = new Headers();

  const token = localStorage.getItem('syncarto_jwt');
  headers.append("Authorization", token ? `Bearer ${token}` : "");
  headers.append("Content-Type", "application/json");

  const response = await fetch(url, {
      method: method,
      headers: headers,
      body: JSON.stringify(body)
  });
  
  if (!response.ok) {
      const message = `${response.status}`;
      throw new Error(message);
  }

  const text = await response.text();
  const data = text ? JSON.parse(text) : null;

  return data;
}
